<template>
  <v-navigation-drawer v-model="drawer" :mini-variant="!isTablesListExpanded" :mini-variant-width="60" width="280" right
    app permanent class="nav-drawer">
    <div class="drawer-content" @mouseenter="handleMouseEnter">
      <!-- Header Section -->
      <div class="drawer-header">
        <v-list-item class="px-2">
          <v-list-item-action>
            <v-btn icon @click.stop="TOGGLE_TABLES_LIST" class="toggle-btn">
              <v-icon size="20" color="#5a6b7c">{{ !isTablesListExpanded ? 'mdi-chevron-left' : 'mdi-chevron-right'
              }}</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-slide-x-transition>
          <div v-if="isTablesListExpanded" class="user-section">
            <div class="user-top">
              <div class="user-avatar">
                <v-icon size="20" color="white">mdi-account</v-icon>
              </div>
              <div class="user-info">
                <span class="user-name">{{ userName }}</span>
                <span class="user-email">{{ email }}</span>
              </div>
              <v-btn icon x-small class="logout-btn" @click="logOut">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" size="18" color="#F44336">mdi-logout-variant</v-icon>
                  </template>
                  <span>יציאה</span>
                </v-tooltip>
              </v-btn>
            </div>

            <v-btn rounded block elevation="0" color="#2196F3" dark small class="account-btn" :to="'/account'" exact>
              <v-icon small class="ml-1">mdi-account-circle</v-icon>
              אזור אישי
            </v-btn>
          </div>
        </v-slide-x-transition>
      </div>

      <!-- Navigation Menu -->
      <v-list dense nav class="nav-list">
        <v-list-item v-for="item in tables" :key="item.name" :to="getRouteForTable(item.name)" exact class="nav-item"
          :class="{ 'mini-list-item': isCollapsed }">
          <v-list-item-icon>
            <div class="nav-icon-wrap" :class="{ 'nav-icon-active': $route.path === getRouteForTable(item.name) }">
              <v-icon size="20" :color="$route.path === getRouteForTable(item.name) ? '#2196F3' : '#90A4AE'">
                {{ item.icon }}
              </v-icon>
            </div>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="nav-item-text" :class="{
              'nav-active-text': $route.path === getRouteForTable(item.name),
              'nav-inactive-text': $route.path !== getRouteForTable(item.name)
            }">
              {{ item.name }}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action v-if="!isCollapsed && $route.path === getRouteForTable(item.name)">
            <div class="active-dot"></div>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import Auth from '@/services/auth.service.js'
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'TablesList',

  props: {
    tableListArray: {
      type: Array,
      required: true
    },
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    drawer: true,
    userName: "",
    email: "",
    tables: [],
    routeMap: {
      "משתמשים": "/users",
      "לקוחות": "/customers",
      "מלאי": "/inventory",
      "הזמנות": "/orders",
      "החלפה והחזרה": "/exchanges",
      "דוחות": "/reports",
      "חפק אונליין": "/online-dashboard",
      "קופה": "/cashier",
      "כניסה והדפסה": "/entry",
      "לפני כניסה": "/pre-entry",
      "הגדרות שעות חלוקה": "/distribution",
      "מלאי טלפוני": "/phone-inventory",
      "מסמכי מס": "/tax-documents",
      "קהילות": "/communities"
    }
  }),

  methods: {
    ...mapMutations(['TOGGLE_TABLES_LIST', 'SET_TABLES_LIST_EXPANDED']), // Import mutation
    getRouteForTable(name) {
      return this.routeMap[name] || '/';
    },

    getUserDetails() {
      this.userName = Auth.getUserName();
      this.email = Auth.getUserEmail();
    },

    logOut() {
      Auth.logout();
      this.$router.replace({ name: "login" });
    },
    handleMouseEnter() {
      if (!this.isTablesListExpanded) {
        this.TOGGLE_TABLES_LIST();
      }
    }
  },
  computed: {
    ...mapState(['isTablesListExpanded']), // Get Vuex state
  },
  watch: {
    isCollapsed(val) {
      this.drawer = !val;
    },

    tableListArray: {
      immediate: true,
      handler(newVal) {
        this.tables = newVal;
      }
    }
  },

  mounted() {
    this.getUserDetails();
  }
}
</script>

<style lang="scss" scoped>
.nav-drawer {
  background: white !important;
  border-left: 1px solid #e8edf2 !important;
  border-right: none !important;
}

.drawer-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* HEADER */
.drawer-header {
  border-bottom: 1px solid #f1f5f9;
}

.toggle-btn {
  border: 1px solid #e8edf2;
  border-radius: 10px !important;
  transition: all 0.2s;

  &:hover {
    background: #f8fafc !important;
  }
}

/* USER SECTION */
.user-section {
  padding: 0 1rem 1rem;
  transition: all 0.3s ease;
}

.user-top {
  display: flex;
  align-items: center;
  gap: .65rem;
  margin-bottom: .75rem;
}

.user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #2196F3, #1565C0);
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  display: block;
  font-size: .88rem;
  font-weight: 700;
  color: #1a2b3c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email {
  display: block;
  font-size: .68rem;
  color: #90A4AE;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logout-btn {
  border: 1px solid #FFEBEE;
  border-radius: 8px !important;
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
    background: #FFF5F5 !important;
  }
}

.account-btn {
  height: 36px !important;
  font-weight: 700;
  font-size: .78rem;
  text-transform: none;
  border-radius: 10px !important;
  letter-spacing: 0;
}

/* NAVIGATION LIST */
.nav-list {
  flex-grow: 1;
  overflow-y: auto;
  padding: .5rem .4rem;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e0e5ec;
    border-radius: 2px;
  }
}

.nav-item {
  border-radius: 10px !important;
  margin: 2px 4px;
  min-height: 42px;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f8fc !important;
  }

  &.v-list-item--active {
    background: #E3F2FD !important;

    &::before {
      opacity: 0;
    }
  }
}

.nav-icon-wrap {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  transition: all 0.2s;
}

.nav-icon-active {
  background: #E3F2FD;
}

.nav-item-text {
  font-size: .82rem;
}

.nav-active-text {
  font-weight: 700;
  color: #1565C0;
}

.nav-inactive-text {
  font-weight: 500;
  color: #5a6b7c;
}

.active-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2196F3;
  box-shadow: 0 0 6px rgba(33, 150, 243, 0.4);
}

/* MINI MODE */
.mini-list-item {
  justify-content: center;
  padding-left: 0;
  margin: 2px auto;
  width: 44px;

  &:hover {
    transform: scale(1.05);
  }
}

/* RTL Support */
.v-application--is-rtl {
  .nav-item {
    &:hover {
      transform: translateX(2px);
    }
  }

  .v-list-item__action:first-child {
    margin-right: 0;
    margin-left: 12px;
  }

  .v-list-item__icon:first-child {
    margin-right: 0;
    margin-left: 12px;
  }
}
</style>